import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { EventsKey } from 'ol/events';
import { unByKey } from 'ol/Observable';
import { toLonLat } from 'ol/proj';
import { CalculationModel } from '../models/calculations';
import { CalculationSettingsModel, RNAVModel } from '../models/configuration';
import { coverageDTO } from '../models/coverageDTO';
import { NavaidDTOCalculation, NavaidModel, ScreeningAngRestrictions } from '../models/navaid';
import { NavaidFromMapDTO, NavaidFromMapModel } from '../models/navaidFromMap';
import { PerformanceDTO } from '../models/performanceDTO';
import { CalculationsService } from './calculations.service';
import { ConfigurationService } from './configuration.service';
import { CoordenateService } from './coordenate.service';
import { MapService } from './map.service';
import { ModalControlService } from './modal-control.service';
import { NavaidsService } from './navaids.service';
import { PointsService } from './points.service';
import { ProjectService } from './project.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class NavaidFromMapService {

  active : boolean;
  fullScreenMode: boolean = false;
  unlockAcceptNavaid : boolean = false;
  navaidFromMapModel : NavaidFromMapModel;
  eventKey: EventsKey;
  constructor(private configurationService : ConfigurationService,
    private pointsController : PointsService,
    private utilsService : UtilsService,
    private calculationService : CalculationsService,
    private projectService : ProjectService,
    private modalService : ModalControlService,
    private mapService : MapService,
    private navaidService : NavaidsService,
    private rcsControl: CoordenateService
    ) {
    this.active = false;
    this.navaidFromMapModel = new NavaidFromMapModel();
  }
  openWindow(){
    this.active = true;
  }

  useOnlyClickPointChanged(): void{
    //this.navaidController.navaidFromMapModel.onlyClickedPoint = !this.navaidController.navaidFromMapModel.onlyClickedPoint;
      if(this.navaidFromMapModel.onlyClickedPoint){
        this.navaidFromMapModel.perform = "Coverage";
        var map = this.mapService.getMap('map');
        this.eventKey = map.on("dblclick", (evt) => {
          evt.preventDefault();
          if(this.active){
            var coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
            var lat = coords[1];
            var lon = coords[0];

            this.navaidService.initializeIcaoCodes(evt.coordinate[1], evt.coordinate[0]);
            this.navaidFromMapModel.latitude = lat;
            this.navaidFromMapModel.longitude = lon;
            this.navaidFromMapModel.latLonDms.fromLat(lat);
            this.navaidFromMapModel.latLonDms.fromLon(lon);
            this.calculateNavaid();
          }
        });
      }
      else{
        unByKey(this.eventKey);
      }
  }
  closeWindow(){
    this.active = false;
    unByKey(this.eventKey); // include in switch function
  }

  createNavaidFromMap(): void{
    if(this.projectService.projectEditable()){
      this.openWindow();
      this.navaidFromMapModel = new NavaidFromMapModel();
      this.fillConfigInfo();
      this.useOnlyClickPointChanged();
    }
  }
  fillConfigInfo(): void {
    this.navaidFromMapModel.singleAltitude = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT;
    this.navaidFromMapModel.singleAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeM;
    this.navaidFromMapModel.maxAltitude = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeFT;
    this.navaidFromMapModel.maxAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeM;
    this.navaidFromMapModel.minAltitude = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeFT;
    this.navaidFromMapModel.minAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeM;
    this.navaidFromMapModel.altitudeInterval = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementFT;
    this.navaidFromMapModel.altitudeIntervalMeters = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementM;
    this.navaidFromMapModel.doc = this.configurationService.currentConfiguration.rnav.maxDME;
  }

  async calculateNavaid() {
    var model : NavaidFromMapDTO = new NavaidFromMapDTO();
    if(this.navaidFromMapModel.perform == "CoveragePerformance" || this.navaidFromMapModel.perform == "Coverage"){
      model.coverage = new coverageDTO();
    }
    if(this.navaidFromMapModel.perform == "CoveragePerformance" || this.navaidFromMapModel.perform == "Performance"){
      model.performance = new PerformanceDTO();
    }
    var navaidsList : NavaidDTOCalculation[] = [];
    var navaid : NavaidDTOCalculation = this.getFakeNavaid();
    const someVal = await (await this.pointsController.getTerrainElevation(navaid.latitude, navaid.longitude)).toPromise();
    navaid.effectiveHeight = someVal;// + this.pointsController.convertToMeters(6);

    navaidsList.push(navaid);
    for await (const element of this.pointsController.getSelectedFeatures()) {
      if(element.getProperties().featureType == 0){
        var navaidDto : NavaidDTOCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(element);
        try{
          const someVal = await (await this.pointsController.getTerrainElevation(navaidDto.latitude, navaidDto.longitude)).toPromise();
          navaidDto.effectiveHeight = someVal + this.pointsController.convertToMeters(element.get('antheight'));
          navaidsList.push(navaidDto);
        }catch(e){
          this.modalService.showMesssageModal("Error", "Error performing Calculation: Could not get Elevation.");
          throw e;
        }
      }
    };

    if(navaidsList.length <= 1 && !this.navaidFromMapModel.onlyClickedPoint){
      this.modalService.showMesssageModal("NavAid Creation From Map", "Please select NavAids to execute coverage and performance analysis.");
      return;
    }

    if(model.coverage != null){
      model.coverage.name = "FromMapCoverage_" + moment.now();
      if(this.navaidFromMapModel.singleLevel){
        model.coverage.minAltitude = this.navaidFromMapModel.singleAltitude / 100;
        model.coverage.maxAltitude = this.navaidFromMapModel.singleAltitude / 100;
        model.coverage.altitudeInterval = 0;
      }
      else{
        model.coverage.minAltitude = this.navaidFromMapModel.minAltitude / 100;
        model.coverage.maxAltitude = this.navaidFromMapModel.maxAltitude / 100;
        model.coverage.altitudeInterval= this.navaidFromMapModel.altitudeInterval / 100;
      }

      model.coverage.navaids = navaidsList;
      model.coverage.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
      model.coverage.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);
      this.calculationService.calculateCoverage(model.coverage, true);
      this.unlockAcceptNavaid = true;
    }
    if(model.performance != null){
      model.performance.name = "FromMapPerformance_" + moment.now();
      if(this.navaidFromMapModel.singleLevel){
        model.performance.flightLevel = this.navaidFromMapModel.singleAltitude / 100;
        model.performance.altitudeInterval = 1;
        model.performance.maxAltitude = this.navaidFromMapModel.singleAltitude / 100;
        model.performance.minAltitude = this.navaidFromMapModel.singleAltitude / 100;

      }
      else{
        model.performance.minAltitude = this.navaidFromMapModel.minAltitude / 100;
        model.performance.maxAltitude = this.navaidFromMapModel.maxAltitude / 100;
        model.performance.altitudeInterval = this.navaidFromMapModel.altitudeInterval / 100;
      }
      model.performance.calculationType = 0;
      model.performance.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
      model.performance.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);
      model.performance.navaids = navaidsList;
      this.calculationService.calculatePerformance(model.performance, true);
      this.unlockAcceptNavaid = true;
    }
  }


  getFakeNavaid() : NavaidDTOCalculation {
    let navaid : NavaidDTOCalculation = new NavaidDTOCalculation();
    navaid.id = "XXX";
    navaid.type = "DME";
    navaid.latitude = this.navaidFromMapModel.latitude;
    navaid.longitude = this.navaidFromMapModel.longitude;
    navaid.doc = this.navaidFromMapModel.doc;
    navaid.maxaltitudeMeters = this.utilsService.feetToMeters(60000);
    navaid.maxOperationalFL = 60000 / 100; // TODO
    navaid.maxaltitude = 60000;
    navaid.coneOfSilenceAngle = 50;
    navaid.uniqueId = "XXX_XX_DME";
    navaid.forceCalculation = false;
    navaid.mtbo = 0;
    navaid.LOSMarginAngle = 0;
    // navaid.VORDMEDocConstrain = arg0.get('vordocmaxrange');
    // navaid.transmutPower = arg0.get('transmoutpower');
    navaid.usesKeyHoling = true;
    navaid.vorFrequency = 1070;
    navaid.screeningAngRestrictionsCount = 0;
    navaid.screeningAngRestrictions = new Array<ScreeningAngRestrictions>();
    navaid.sectorizations = [];
    navaid.sortedSectors = [];
    return navaid;
  }
}
